import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { sessionManager } from "../../managers/sessionManager";
import { httpConstants } from "../../constants";

/**
 * Route guard enforcing "no plan, no usage" in the UI. Wrap routes that lead to paid
 * AI generation (brand onboarding, generation flows). A logged-in user without an
 * active subscription is sent to /select-plan. Note: the server-side TokenGuard in
 * brand-microservice is the hard guarantee; this gate is the UX layer on top of it.
 */
const hasActiveSubscription = (reduxSub) => {
  if (reduxSub) return true;
  try {
    const info = JSON.parse(localStorage.getItem("info"));
    return !!info?.subscriptionDetails;
  } catch (e) {
    return false;
  }
};

const SubscriptionGate = ({ children }) => {
  const token = sessionManager.getDataFromCookies(
    httpConstants.HEADERS.AUTH0_ID_TOKEN
  );
  const reduxSub = useSelector(
    (state) => state?.user?.info?.subscriptionDetails
  );

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  if (!hasActiveSubscription(reduxSub)) {
    return <Navigate to="/select-plan" replace />;
  }
  return children;
};

export default SubscriptionGate;
